import './style/bolmateSegmentedToggle.scss';

import React from 'react';

import classNames from 'classnames';

export interface SegmentedToggleOption<T extends string> {
    value: T;
    label: string;
}

interface Props<T extends string> {
    options: Array<SegmentedToggleOption<T>>;
    value: T;
    onChange: (value: T) => void;
    className?: string;
}

export default function BolmateSegmentedToggle<T extends string>({options, value, onChange, className}: Props<T>) {
    return (
        <div className={classNames('bolmate-segmented-toggle', className)}>
            {options.map(option => (
                <button
                    key={option.value}
                    className={classNames('segment-btn', value === option.value && 'active')}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
